/* ── Admin Watch Modal (ES Module) ── */
import { catalog } from './admin-globals.js';
import { getNowPlaying } from './core/schedule-engine.js';

let _watchFogRAF = null;
let _watchTimer = null;
let _watchMuted = false;
let _watchChIdx = -1;
let _watchVolume = 0.5;

function startWatchFog() {
  const canvas = document.getElementById('watch-fog-canvas');
  if (!canvas) return;
  canvas.width = 640; canvas.height = 480;
  const ctx = canvas.getContext('2d');
  function frame() {
    const img = ctx.createImageData(canvas.width, canvas.height);
    for (let i = 0; i < img.data.length; i += 4) {
      const v = Math.random() * 255 | 0;
      img.data[i] = img.data[i+1] = img.data[i+2] = v;
      img.data[i+3] = 255;
    }
    ctx.putImageData(img, 0, 0);
    _watchFogRAF = requestAnimationFrame(frame);
  }
  frame();
}

function stopWatchFog() {
  if (_watchFogRAF) { cancelAnimationFrame(_watchFogRAF); _watchFogRAF = null; }
}

export function changeWatchChannel(dir) {
  const syncChannels = catalog
    .map((ch, i) => ({ ch, i }))
    .filter(({ ch }) => ch.sync && ch.videos.some(v => (v.duration || 0) > 0));
  if (!syncChannels.length) return;

  const pos = syncChannels.findIndex(({ i }) => i === _watchChIdx);
  const next = syncChannels[(pos + dir + syncChannels.length) % syncChannels.length];

  const screen = document.getElementById('watch-screen');
  const staticEl = document.getElementById('watch-static');
  const fog = document.getElementById('watch-yt-fog');
  
  // Activar NIEBLA y ZAPPING inmediatamente
  stopWatchFog();
  startWatchFog();
  if (fog) fog.classList.add('show');
  
  staticEl.classList.add('active');
  screen.classList.add('zapping');

  setTimeout(() => {
    openWatchModal(next.i);
    setTimeout(() => {
      staticEl.classList.remove('active');
      screen.classList.remove('zapping');
    }, 200);
  }, 300);
}

export function openWatchModal(chIdx) {
  _watchChIdx = chIdx;
  clearInterval(_watchTimer);
  clearTimeout(window._watchOsdTimer);
  const ch = catalog[chIdx];
  const np = getNowPlaying(ch);
  if (!np) return;
  const { vid, elapsed, total } = np;

  // 🎨 Sintonizar plantilla del canal en el preview
  const wrapper = document.getElementById('watch-tv-case');
  if (wrapper) {
    wrapper.setAttribute('data-template', ch.template || 'RapTV');
  }

  const osdCh = document.getElementById('watch-osd-ch');
  osdCh.textContent = `CH ${ch.num}`;
  osdCh.style.color = ch.color;
  
  const osdFs = document.getElementById('watch-osd-ch-fs');
  if (osdFs) osdFs.textContent = `CH ${String(ch.num).padStart(2, '0')}`;
  
  document.getElementById('watch-osd-name').textContent = ch.name.toUpperCase();

  document.getElementById('watch-lower-bar').style.borderColor = ch.color;
  document.getElementById('watch-lower-label').style.color = ch.color;
  document.getElementById('watch-lower-title').textContent = vid.title;

  document.getElementById('watch-ch-display').textContent = String(ch.num).padStart(2, '0');

  _watchMuted = false;
  const knob = document.getElementById('watch-vol-knob');
  knob.style.opacity = '1';
  knob.style.transform = `rotate(${(_watchVolume * 300) - 150}deg)`;
  document.getElementById('watch-vol-label').textContent = 'VOL';

  const ytContainer = document.getElementById('watch-yt-container');
  const ytEl = document.getElementById('watch-yt');
  const videoEl = document.getElementById('watch-video');
  const blocker = document.getElementById('watch-yt-blocker');
  const fog = document.getElementById('watch-yt-fog');
  
  ytContainer.style.display = 'none'; 
  ytEl.src = '';
  videoEl.style.display = 'none'; 
  videoEl.src = '';
  blocker.style.display = 'none';
  
  // Mostrar niebla mientras carga
  stopWatchFog();
  startWatchFog();
  fog.classList.add('show');

  if (vid.type === 'youtube') {
    ytContainer.style.display = 'block';
    blocker.style.display = 'block';
    // 🔧 Mejora #2: mute=1 solo en iOS/Safari — es el único modo que permite autoplay con audio
    // en WebKit. En desktop no es necesario y evitamos silenciar el preview innecesariamente.
    const iosMute = (window.RAPTV_PLATFORM && window.RAPTV_PLATFORM.ios) ? '&mute=1' : '';
    // enablejsapi=1 permite controlar el player vía postMessage (mute/unmute) y recibir eventos
    ytEl.src = `https://www.youtube.com/embed/${vid.id}?autoplay=1&start=${Math.floor(elapsed)}&rel=0&modestbranding=1&enablejsapi=1${iosMute}&origin=${window.location.origin}`;
    // 🔧 Fix #8: En vez de esperar 1500ms fijos, escuchar onStateChange PLAYING del iframe.
    // En red lenta, 1500ms puede no ser suficiente y el fog desaparece antes del vídeo.
    // Fallback a 4s por si el iframe no responde (bloqueador de anuncios, restricción de región).
    const watchYtListener = (e) => {
      try {
        const data = JSON.parse(e.data);
        if (data.event === 'onStateChange' && data.info === 1) { // 1 = PLAYING
          window.removeEventListener('message', watchYtListener);
          clearTimeout(watchYtFallback);
          fog.classList.remove('show');
          setTimeout(stopWatchFog, 1000);
        }
      } catch(_) {}
    };
    window.addEventListener('message', watchYtListener);
    const watchYtFallback = setTimeout(() => {
      window.removeEventListener('message', watchYtListener);
      fog.classList.remove('show');
      setTimeout(stopWatchFog, 1000);
    }, 4000);
  } else {
    videoEl.style.display = 'block';
    videoEl.src = vid.url;
    videoEl.muted = false;
    videoEl.addEventListener('canplay', () => {
      fog.classList.remove('show');
      setTimeout(stopWatchFog, 1000);
      videoEl.currentTime = elapsed;
      videoEl.play().catch(() => {});
    }, { once: true });
  }

  const screen = document.getElementById('watch-screen');
  screen.classList.remove('tv-off');
  void screen.offsetWidth;
  screen.classList.add('tv-on');
  setTimeout(() => screen.classList.remove('tv-on'), 550);

  const osd = document.getElementById('watch-osd');
  const lower = document.getElementById('watch-lower');
  osd.style.opacity = '1'; osd.style.transition = 'opacity 0.5s';
  lower.style.opacity = '1';
  clearTimeout(window._watchOsdTimer);
  window._watchOsdTimer = setTimeout(() => {
    osd.style.opacity = '0';
    lower.style.opacity = '0';
  }, 4000);

  const modal = document.getElementById('watch-modal');
  modal.classList.remove('hidden');
  modal.classList.add('visible');
  document.body.style.overflow = 'hidden';

  _watchTimer = setInterval(() => {
    const np2 = getNowPlaying(ch);
    if (!np2) return;
    const lowerTitle = document.getElementById('watch-lower-title');
    if (np2.vid.title !== lowerTitle.textContent) {
      lowerTitle.textContent = np2.vid.title;
      const lower = document.getElementById('watch-lower');
      lower.style.opacity = '1';
      clearTimeout(window._watchOsdTimer);
      window._watchOsdTimer = setTimeout(() => { lower.style.opacity = '0'; }, 4000);
    }
  }, 1000);
}

export function toggleWatchFullscreen() {
  const modal = document.getElementById('watch-modal');
  const isFs = modal.classList.toggle('watch-fullscreen');
  document.getElementById('watch-fs-btn').textContent = isFs ? '✕' : '⛶';
  document.body.style.overflow = 'hidden';
}

export function toggleWatchMute() {
  _watchMuted = !_watchMuted;

  // Controlar el elemento <video> HTML5
  const videoEl = document.getElementById('watch-video');
  if (videoEl) videoEl.muted = _watchMuted;

  // 🔧 Fix: controlar también el iframe de YouTube via postMessage.
  // Antes el botón de mute era inoperativo cuando el canal usaba YouTube.
  // Requiere enablejsapi=1 en la URL del embed (añadido en openWatchModal).
  const ytEl = document.getElementById('watch-yt');
  if (ytEl && ytEl.contentWindow) {
    try {
      ytEl.contentWindow.postMessage(JSON.stringify({
        event: 'command',
        func: _watchMuted ? 'mute' : 'unMute',
        args: []
      }), '*');
    } catch(_) {}
  }

  const knob = document.getElementById('watch-vol-knob');
  const label = document.getElementById('watch-vol-label');
  knob.style.opacity = _watchMuted ? '0.35' : '1';
  label.textContent = _watchMuted ? 'MUTE' : 'VOL';

  if (_watchMuted) {
    knob.style.transform = 'rotate(-150deg)';
  } else {
    const deg = (_watchVolume * 300) - 150;
    knob.style.transform = `rotate(${deg}deg)`;
  }
}

export function openSingleVideoPreview(vid) {
  _watchChIdx = -1;
  // 🔧 Fix #6: Limpiar el timer del canal anterior antes de abrir el preview.
  // Sin esto, si había un canal watch activo (con _watchTimer corriendo), el
  // setInterval seguía actualizando el lower-bar con el título del canal anterior
  // mientras se mostraba la preview del nuevo vídeo.
  clearInterval(_watchTimer);
  clearTimeout(window._watchOsdTimer);

  // 🎨 Aplicar plantilla del canal seleccionado o default
  const wrapper = document.getElementById('watch-tv-case');
  if (wrapper) {
    const templateName = (window.catalog && window.selectedChannel !== null && window.catalog[window.selectedChannel]) 
      ? (window.catalog[window.selectedChannel].template || 'RapTV')
      : 'RapTV';
    wrapper.setAttribute('data-template', templateName);
  }

  clearInterval(_watchTimer);
  clearTimeout(window._watchOsdTimer);

  const osdCh = document.getElementById('watch-osd-ch');
  osdCh.textContent = `PV`;
  osdCh.style.color = '#00FFFF';
  
  const osdFs = document.getElementById('watch-osd-ch-fs');
  if (osdFs) osdFs.textContent = `PREVIEW`;
  
  document.getElementById('watch-osd-name').textContent = "VIDEO PREVIEW";

  document.getElementById('watch-lower-bar').style.borderColor = '#00FFFF';
  document.getElementById('watch-lower-label').style.color = '#00FFFF';
  document.getElementById('watch-lower-title').textContent = vid.title || vid.name || "UNNAMED VIDEO";

  document.getElementById('watch-ch-display').textContent = "--";
  
  // Ocultar botones de canal
  const chButtons = document.querySelector('#watch-tv-controls .channel-buttons');
  if (chButtons) chButtons.style.visibility = 'hidden';

  _watchMuted = false;
  const knob = document.getElementById('watch-vol-knob');
  knob.style.opacity = '1';
  knob.style.transform = `rotate(${(_watchVolume * 300) - 150}deg)`;
  document.getElementById('watch-vol-label').textContent = 'VOL';

  const ytContainer = document.getElementById('watch-yt-container');
  const ytEl = document.getElementById('watch-yt');
  const videoEl = document.getElementById('watch-video');
  const blocker = document.getElementById('watch-yt-blocker');
  
  ytContainer.style.display = 'none'; 
  ytEl.src = '';
  videoEl.style.display = 'none'; 
  videoEl.src = '';
  blocker.style.display = 'none';

  if (vid.type === 'youtube') {
    ytContainer.style.display = 'block';
    blocker.style.display = 'block';
    // enablejsapi=1 permite controlar el player vía postMessage
    ytEl.src = `https://www.youtube.com/embed/${vid.id}?autoplay=1&rel=0&modestbranding=1&enablejsapi=1&origin=${window.location.origin}`;
  } else {
    videoEl.style.display = 'block';
    videoEl.src = vid.url;
    videoEl.muted = false;
    videoEl.play().catch(() => {});
  }

  const screen = document.getElementById('watch-screen');
  screen.classList.remove('tv-off');
  void screen.offsetWidth;
  screen.classList.add('tv-on');

  const osd = document.getElementById('watch-osd');
  const lower = document.getElementById('watch-lower');
  osd.style.opacity = '1'; 
  lower.style.opacity = '1';
  
  const modal = document.getElementById('watch-modal');
  modal.classList.remove('hidden');
  modal.classList.add('visible');
  document.body.style.overflow = 'hidden';
}

export function closeWatchModal() {
  clearInterval(_watchTimer);
  clearTimeout(window._watchOsdTimer);
  document.getElementById('watch-modal').classList.remove('watch-fullscreen');
  document.getElementById('watch-fs-btn').textContent = '⛶';
  
  const addBtn = document.getElementById('watch-add-btn');
  if (addBtn) addBtn.classList.add('hidden');

  const chButtons = document.querySelector('#watch-tv-controls .channel-buttons');
  if (chButtons) chButtons.style.visibility = 'visible';

  const screen = document.getElementById('watch-screen');
  screen.classList.remove('tv-on');
  screen.classList.add('tv-off');
  setTimeout(() => {
    const modal = document.getElementById('watch-modal');
    modal.classList.remove('visible');
    modal.classList.add('hidden');
    document.getElementById('watch-yt').src = '';
    document.getElementById('watch-yt-container').style.display = 'none';
    const v = document.getElementById('watch-video');
    v.pause(); v.src = '';
    screen.classList.remove('tv-off');
    document.body.style.overflow = '';
  }, 400);
}

// Global listener for Watch Modal keys
document.addEventListener('keydown', e => {
  const modal = document.getElementById('watch-modal');
  if (!modal || !modal.classList.contains('visible')) return;
  if (e.key === 'Escape' && !document.fullscreenElement) closeWatchModal();
  if (e.key === 'f' || e.key === 'F') toggleWatchFullscreen();
  if (e.key === 'ArrowRight' || e.key === 'ArrowUp')  changeWatchChannel(1);
  if (e.key === 'ArrowLeft'  || e.key === 'ArrowDown') changeWatchChannel(-1);
});

// Close modal when clicking outside the TV case
document.addEventListener('click', e => {
  const modal = document.getElementById('watch-modal');
  if (!modal || !modal.classList.contains('visible')) return;
  
  // Solo cerrar si el click es exactamente en el overlay del modal
  if (e.target === modal) {
    closeWatchModal();
  }
});

// ── Volume Control Logic ──
document.addEventListener('DOMContentLoaded', () => {
  const knob = document.getElementById('watch-vol-knob');
  if (!knob) return;

  let isDragging = false;
  let dragMoved = false;
  let startY = 0;
  let startVol = 0;

  const updateVol = (newVol) => {
    const videoEl = document.getElementById('watch-video');
    _watchVolume = Math.max(0, Math.min(1, newVol));
    if (videoEl) videoEl.volume = _watchVolume;

    if (_watchMuted) {
      _watchMuted = false;
      const label = document.getElementById('watch-vol-label');
      knob.style.opacity = '1';
      label.textContent = 'VOL';
      if (videoEl) videoEl.muted = false;
    }

    const deg = (_watchVolume * 300) - 150;
    knob.style.transform = `rotate(${deg}deg)`;
  };

  // MECÁNICA 1: SCROLL
  knob.addEventListener('wheel', e => {
    e.preventDefault();
    updateVol(_watchVolume + (e.deltaY > 0 ? -0.05 : 0.05));
  }, { passive: false });

  // MECÁNICA 2: CLICK + ARRASTRAR
  knob.addEventListener('mousedown', e => {
    isDragging = true;
    dragMoved = false;
    startY = e.clientY;
    startVol = _watchVolume;
    document.body.style.cursor = 'ns-resize';
    document.body.style.userSelect = 'none';
    e.preventDefault();
  });

  document.addEventListener('mousemove', e => {
    if (!isDragging) return;
    dragMoved = true;
    const diff = startY - e.clientY; 
    // Sensibilidad: 150px para el rango 0.0 a 1.0 (más suave y reactivo)
    const sensitivity = 150; 
    updateVol(startVol + (diff / sensitivity));
  });

  document.addEventListener('mouseup', () => {
    if (isDragging) {
      isDragging = false;
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    }
  });

  // MECÁNICA 3: CLICK PARA MUTE (Solo si no hubo drag)
  knob.addEventListener('click', () => {
    if (!dragMoved) {
      toggleWatchMute();
    }
  });
});